"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROGRESS_STEPPER_LABEL_ALIGNMENTS = void 0;
var PROGRESS_STEPPER_LABEL_ALIGNMENTS = Object.freeze({
  CENTER: 'center',
  LEFT: 'left'
});
exports.PROGRESS_STEPPER_LABEL_ALIGNMENTS = PROGRESS_STEPPER_LABEL_ALIGNMENTS;